import { supabase } from '../lib/supabase';

const BUCKET_NAME = 'blog-images';

export const storageService = {
  /**
   * Upload an image to blog-images bucket
   * @param {File} file - The image file to upload
   * @returns {Promise<string>} - The public URL of the uploaded image
   */
  async uploadBlogImage(file) {
    try {
      // Generate unique filename
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${Date.now()}-${Math.random()?.toString(36)?.substring(7)}.${fileExt}`;
      const filePath = `content/${fileName}`;

      // Upload file
      const { data, error } = await supabase?.storage
        ?.from(BUCKET_NAME)
        ?.upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) throw error;

      // Get public URL
      const { data: urlData } = supabase?.storage
        ?.from(BUCKET_NAME)
        ?.getPublicUrl(filePath);

      return urlData?.publicUrl;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw new Error(error?.message || 'Failed to upload image');
    }
  },

  /**
   * Delete an image from blog-images bucket
   * @param {string} imageUrl - The public URL of the image to delete
   * @returns {Promise<void>}
   */
  async deleteBlogImage(imageUrl) {
    try {
      // Extract file path from URL
      const urlParts = imageUrl?.split(`${BUCKET_NAME}/`);
      if (urlParts?.length < 2) {
        throw new Error('Invalid image URL');
      }
      const filePath = urlParts?.[1];

      const { error } = await supabase?.storage
        ?.from(BUCKET_NAME)
        ?.remove([filePath]);

      if (error) throw error;
    } catch (error) {
      console.error('Error deleting image:', error);
      throw new Error(error?.message || 'Failed to delete image');
    }
  }
};